import { render, staticRenderFns } from "./jvSearchClass.vue?vue&type=template&id=2ed95ff2"
import script from "./jvSearchClass.vue?vue&type=script&lang=js"
export * from "./jvSearchClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports